// extracted by mini-css-extract-plugin
export default {"custom-select":"SelectProductTransferSerial_custom-select__EgwrT","header-select":"SelectProductTransferSerial_header-select__tMxJL"};